"use client";

import type { UIConversation } from "@/actions/conversations/conversations.type";
import type { QueryClient } from "@tanstack/react-query";
import { conversationQueryKey } from "./query-keys";

export function seedConversationCache(
  queryClient: QueryClient,
  conversation: UIConversation,
) {
  queryClient.setQueryData(
    conversationQueryKey(conversation.id),
    conversation,
  );
}
